import * as moment from 'moment';
import { SelectionItem } from '../../../../shared/dtos/selection-item';
import { ConfigurationOptions } from '../../dtos/confiuration-options.dto';

export abstract class AbstractServiceLevelConfigDialogComponent {
    public selectedMarketSectorIds: number[] = [];
    public selectedDurationIds: number[]|undefined = [];
    public selectedCoverageLevelIds: number[]|undefined = [];

    public durations: SelectionItem[];
    public coverageLevels: SelectionItem[];
    public readonly marketSectors: SelectionItem[];

    public intialLoadDisable: boolean= false;

    public marketSectorProductCodeMap: {[key: string]: {
        productCode: string,
        geogatingMode: string,
        geogatingType: string
    } } = {};

    public constructor(configurationOptions: ConfigurationOptions) {
        this.marketSectors = configurationOptions.marketSectors;
        this.durations = configurationOptions.durations.sort((a, b) => {
            const aDuration = parseInt(a.name);
            const aUnit = a.value.toLowerCase() as moment.unitOfTime.DurationConstructor;
            const aDate = moment().startOf('day').add(1, aUnit);
            const bDuration = parseInt(b.name);
            const bUnit = b.value.toLowerCase() as moment.unitOfTime.DurationConstructor;
            const bDate = moment().startOf('day').add(1, bUnit);

            const diff = aDate.diff(bDate);

            if (diff === 0) {
                return aDuration - bDuration;
            }

            return diff;
        });
        this.coverageLevels = configurationOptions.coverageLevels;
    }

    public disableSaveButton(): boolean {
        const selectedProductCodes = this.selectedMarketSectorIds.map(msId => {
            const productCode = this.marketSectorProductCodeMap[msId].productCode;
            return productCode;
        });
        const invalidProductCodes = !selectedProductCodes.every(i => /[0-9]{4}-[0-9]{2}-[0-9]{1}/.test(i));
        return this.selectedMarketSectorIds.length < 1 ||
            this.selectedDurationIds!.length < 1 ||
            this.selectedCoverageLevelIds!.length < 1 ||
            invalidProductCodes;
    }
}
